import React from 'react';

import AreaHeader from '@app/components/UI/Area-blocks/AreaHeader/AreaHeader';
import CardResource from '@app/components/UI/CardResource/CardResource';
import MiddleText from '@app/components/UI/MiddleText/MiddleText';
import { Area } from '@app/objects/Area';

const AreaResources: React.FC<{ area: Area | undefined}> = ({ area }) => {
	return (
		<>
			<div className="area">
				<AreaHeader area={area} />

				<MiddleText
					title="Local and emergency resources"
					text="If you're seeking additional help and guidance for your pet, you're in good hands. Check out these reputable organizations in your area."
				/>

				<div className="card-resource-wrapper">
					{area?.localResources && (
						area?.localResources.map((resource, index) => (
							<CardResource
								key={index}
								url={resource.url}
								position={resource.title}
								name={resource.description}
								phone={resource.phone}
							/>
						))
					)}
				</div>
			</div>
		</>
	);
};

export default AreaResources;
